import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import Separator from '~/components/Shared/Separator/Separator';

export default component$((): JSX.Element => {
  const appData = useContext(AppDataContext);

  return (
    <Separator color={appData.themeComponents.footer.separatorColor.value} />
  );
});
